import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M7 7l5 5l5 -5","key":"svg-0"}],["path",{"d":"M7 13l5 5l5 -5","key":"svg-1"}]]

const IconChevronsDown = createReactComponent('outline', 'chevrons-down', 'ChevronsDown', __iconNode);

export default IconChevronsDown;